<template>
  <div class="card-info">
    <van-tag
      v-for="item in certificates"
      :key="item.noType"
      size="medium"
      text-color="black"
      color="#eed"
      @click="handleNotype(item)"
    >
      {{ item.title }}
    </van-tag>
  </div>
</template>
<script>
export default {
  data() {
    return {
      certificates: [
        { noType: '1', type: '身份证', title: '身份证' },
        { noType: '2', type: '护照', title: '护照' },
        { noType: '3', type: '港澳台', title: '港澳台' },
        { noType: '4', type: '永居证', title: '外国人永久居住证' },
      ],
    };
  },
  methods: {
    handleNotype(item) {
      this.$emit('change', item);
    },
  },
};
</script>
<style lang="less" scoped>
.card-info {
  position: absolute;
  z-index: 1;
  display: flex;
  flex-direction: column;
  left: 16px;
  top: -59px;
  .van-tag {
    width: 100%;
    padding: 6px;
    &:not(:last-child) {
      border-bottom: 1px solid #ddd;
    }
  }
}
</style>
